export * from './AllocationSelector.styled';
